import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
/**
 * Renders Aviso's standard checkbox
 *
 * @param {Props} props - the props for this component
 */
const Checkbox = (props) => {
    // Create random id.
    const id = "checkbox-" + Math.floor(Math.random() * 10000000);
    const helpId = id + "-help";
    return (_jsxs("div", { className: `custom-control custom-checkbox ${props.className || ""}`, children: [_jsx("input", { 
                // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'.
                checked: props.checked, className: "custom-control-input", onChange: props.onChange, type: "checkbox", id: id, "aria-describedby": props.helpText ? helpId : undefined }), _jsx("label", { className: "custom-control-label", htmlFor: id, children: props.label }), props.helpText && (_jsx("div", { className: "text-muted", children: _jsx("small", { id: helpId, children: props.helpText }) }))] }));
};
export default Checkbox;
